import React from "react";
import ReactDOM from "react-dom";
import LCAppBar from "./pages/appBar";
import * as serviceWorker from "./serviceWorker";
import localizationManager from "./pages/localizationManager";

(async () => {
    const savedLang = localStorage.getItem("userLang");
    await localizationManager.setupLocalization(savedLang);

    ReactDOM.render(<LCAppBar />, document.getElementById("navbar"));
})();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
